import { ReactNode } from 'react'

interface StatItem {
  label: string
  value: ReactNode
}

interface StatsCardProps {
  stats: StatItem[]
}

export function StatsCard({ stats }: StatsCardProps) {
  return (
    <div className="space-y-2 overflow-x-hidden">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="flex justify-between items-start min-h-[28px] gap-3"
        >
          <div className="text-sm font-normal text-gray-600 whitespace-nowrap flex-shrink-0">
            {stat.label}
          </div>
          <div className="text-sm font-medium text-gray-900 text-right min-w-0 break-words tabular-nums">
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  )
}
